type Properties = {
    onClick: () => void;
};

const FavoriteListItemRemoveButton = (props: Properties) => {
    return (
        <button className="favorite-button favorite-button-remove" onClick={props.onClick}>Löschen</button>
    );
};

export default FavoriteListItemRemoveButton;
